import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["button", "panel"]

  toggle(event) {
    event.preventDefault()

    const open = !this.panelTarget.classList.contains("in")

    this.panelTarget.classList.toggle("in", open)
    this.buttonTarget.classList.toggle("collapsed", !open)
    this.buttonTarget.setAttribute("aria-expanded", open.toString())
  }

  closeFromLink(event) {
    if (!event.target.closest("a") || !this.panelTarget.contains(event.target)) return

    this.panelTarget.classList.remove("in")
    this.buttonTarget.classList.add("collapsed")
    this.buttonTarget.setAttribute("aria-expanded", "false")
  }
}
